import { isVueRoute, isHybridEnvironment } from "@/common/functions";

export default {
	methods: {
		pushZebraNavigation(to) {
			let toAsHref = to;
			if (typeof toAsHref !== "string") {
				toAsHref = this.$router.resolve(to).href;
			}

			if (
				typeof window === "object" &&
				!isVueRoute(toAsHref) &&
				isHybridEnvironment(window.location.origin)
			) {
				return window.location.assign(toAsHref);
			}

			this.$router.push(to);
		},
	},
};
